import {UI} from "../../../../../../stem-core/src/ui/UIBase";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {StyleSheet} from "../../../../../../stem-core/src/ui/Style";

import {PanelChooseCard} from "../../donation/components/PanelChooseCard";
import {styleRule} from "../../../../../../stem-core/src/decorators/Style";
import {Messages} from "../../../../../Messages";
import {NOOP_FUNCTION} from "../../../../../../stem-core/src/base/Utils";
import {PaymentMethodStore} from "../../../../../../client/state/PaymentMethodStore";
import {autoredraw} from "../../../../../../stem-core/src/decorators/AutoRedraw.js";


class ChooseCardComponentStyle extends StyleSheet {
    @styleRule
    title = this.themeProps.PANEL_TITLE;

    @styleRule
    list = {
        maxHeight: 209, // The height for 2 cards.
        marginRight: -18,
        paddingRight: 18,
    };
}

// TODO @input ?????
@autoredraw(PaymentMethodStore)
@registerStyle(ChooseCardComponentStyle)
export class ChooseCardComponent extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            card: null,
            onAddCard: NOOP_FUNCTION,
            onChangeCard: NOOP_FUNCTION,
            testId: "chooseCard",
            entry: null,
        };
    }

    constructor(...args) {
        super(...args);

        this.selectedCard = this.options.card;
    }

    isValid() {
        return true;
    }

    getActive() {
        return this.selectedCard;
    }

    // TODO @input why is there a callback here?????
    getPaymentMethodId(scope, callback) {
        callback(this.selectedCard.id);
    }

    handleCardSelection(card) {
        this.selectedCard = card;
        this.redraw();
        this.options.onChangeCard(card);
    }

    render() {
        const {styleSheet} = this;
        const {onAddCard, entry} = this.options;
        // TODO @cleanup it seems like entry should just default to PaymentMethodStore, and should be renamed to paymentMethods
        const cardsCount = entry ? entry.getAvailablePaymentMethods().length
                : PaymentMethodStore.getAvailablePaymentMethods().length;

        return [
            <div className={styleSheet.title}>{Messages.cardComponentTitle}</div>,
            <PanelChooseCard
                onAddCard={onAddCard}
                onCardSelected={(card) => this.handleCardSelection(card)}
                selected={this.selectedCard}
                hideActiveCard={true}
                className={styleSheet.list}
                style={{overflow: cardsCount > 2 ? "auto" : "hidden"}}
                showHeader={true}
                recurringPayment={entry}
                showDescription={true}
            />,
        ]
    }
}
